import PartnersView from './PartnersView';
import PartnerEditDrawer from './PartnerEditDrawer';
import PartnerPaymentsTab from './PartnerPaymentsTab';
import PartnerFeesTab from './PartnerFeesTab';
import PartnerPricingTab from './PartnerPricingTab';
import CreatePartnerDrawer from './CreatePartnerDrawer';

export default {
  PartnersView,
  PartnerEditDrawer,
  PartnerPaymentsTab,
  PartnerFeesTab,
  PartnerPricingTab,
  CreatePartnerDrawer,
};
